import React from 'react';

import HeroSlider from '../components/HeroSlider';
import AboutSection from '../components/home/AboutSection';
import StatsSection from '../components/home/StatsSection';
import ServicesSection from '../components/home/ServicesSection';
import ProjectsSection from '../components/home/ProjectsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ClientsSection from '../components/home/ClientsSection';
import CTASection from '../components/home/CTASection';
import NewsSection from '../components/home/NewsSection';
import BatteriesSection from '../components/home/BatteriesSection';

const Home = () => {
  return (
    <div>
      <HeroSlider />
      <AboutSection />
      <StatsSection />
      <ServicesSection />
      <ProjectsSection />
      <TestimonialsSection />
      <ClientsSection />
      <CTASection />
      <NewsSection />
      <BatteriesSection />
    </div>
  );
};

export default Home;
